import Vue from 'vue'
import Router from 'vue-router'
import SessionCmp from './vcs/session/cmp.vue'
import LoginCmp from './vcs/session/login/cmp.vue'
import AbstractRouteCmp from './vcs/_shared/abstract-route-cmp.vue'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import CustomLoginCallback from './vcs/session/LoginCallback'

// https://stackoverflow.com/a/63263736
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }

  return originalPush.call(this, location).catch(err => {
    if (Router.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

export default function createRouter(oktaConfig) {
  Vue.use(Router)

  if (oktaConfig.clientId && oktaConfig.issuer && oktaConfig.oktaLogin === true) {
    const oktaAuth = new OktaAuth(oktaConfig)
    Vue.use(OktaVue, { oktaAuth })
  }

  const router = new Router({
    mode: 'history',
    base: `/`,
    routes: [
      {
        path: '/',
        component: SessionCmp,
        meta: { auth: 'opened' },
        children: [
          {
            path: '',
            component: LoginCmp,
            meta: { auth: 'opened' },
          },
          {
            path: 'register',
            component: () => import('./vcs/session/register/cmp.vue'),
            meta: { auth: 'opened' },
          },
          {
            name: 'RecoverPassword',
            path: 'recover-password',
            component: () => import('./vcs/session/recover-password/cmp.vue'),
            meta: { auth: 'logoutAndGo' },
          },
          {
            name: 'SignInWithCode',
            path: 'sign-in-with-code',
            component: () => import('./vcs/session/sign-in-with-code/cmp.vue'),
            // meta: { auth: "logoutAndGo" },
            meta: { auth: 'opened' },
          },
          {
            path: 'set-password/:token',
            component: () => import('./vcs/session/set-password/cmp.vue'),
            meta: { auth: 'logoutAndGo' },
          },
          {
            path: 'okta-setup',
            component: () => import('./vcs/session/okta-setup/cmp.vue'),
            meta: { auth: 'opened' },
          },
          {
            path: 'sso-sign-in',
            component: () => import('./vcs/session/session-sso-callback.vue'),
            meta: { auth: 'opened' },
          },
          {
            path: 'aad-sso-sign-in',
            component: () => import('./vcs/session/aad-sso-callback.vue'),
            meta: { auth: 'opened' },
          },
          {
            path: 'aad-sso-sign-out',
            component: () => import('./vcs/session/aad-sso-sign-out.vue'),
            meta: { auth: 'opened' },
          },
        ],
      },

      {
        path: '/login/callback',
        // component: LoginCallback,
        component: CustomLoginCallback,
      },
      {
        path: '/offline',
        component: () => import('./vcs/offline/cmp.vue'),
        meta: { auth: 'opened' },
      },
      {
        path: '/lockers',
        component: () => import('./vcs/lockers/cmp.vue'),
      },
      {
        path: '/delivery',
        component: () => import('./vcs/delivery/cmp.vue'),
      },
      {
        path: '/profile',
        component: AbstractRouteCmp,
        children: [
          {
            path: '',
            component: () => import('./vcs/profile/cmp.vue'),
          },
          {
            path: 'name',
            component: () => import('./vcs/profile/name/cmp.vue'),
          },
          {
            path: 'my-collectomates',
            component: () => import('./vcs/profile/my-collectomates/cmp.vue'),
          },
          {
            path: 'phone',
            component: AbstractRouteCmp,
            children: [
              {
                path: '',
                component: () => import('./vcs/profile/phone/cmp.vue'),
              },
              {
                path: 'verification',
                component: () => import('./vcs/profile/phone/verification/cmp.vue'),
              },
            ],
          },
          {
            path: 'delivery-code',
            component: () => import('./vcs/profile/delivery-code/cmp.vue'),
          },
        ],
      },
      { path: '*', redirect: '/' },
    ],
  })
  return router
}
